import { logger } from "@octopusdeploy/logging";
import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
export function useIsTrial(): boolean {
    const { result, error } = useInlineStatusQuery(async (repository) => await repository.Licenses.getCurrentStatus(), [], "Get license current status");
    if (error) {
        logger.warn(`Error fetching license status: ${error.message}`);
        return false;
    }
    return result ? result.IsTrial : false;
}
